/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import {gsap} from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      const links = [];

      $( '.wysiwyg > *:header' ).each( function( key, val ) {
        if ( $( this ).text().trim().length ) {
          $( this ).attr( 'id', 'heading-' + Math.random().toString( 16 ).slice( 2 ) );
          if ( this.nodeName == 'H2' ) {
            links.push( {type: 'large-heading', text: $( this ).text(), id: $( this ).attr( 'id' )} );
          } else {
            links.push( {type: 'small-heading', text: $( this ).text(), id: $( this ).attr( 'id' )} );
          }
        }
      } );

      if ( links.length > 0 ) {
        $( '.jump-links-wrapper' ).show();
      }

      $( links ).each( function( key, val ) {
        if ( val.type == 'large-heading' ) {
          $( '.jump-links-wrapper' ).append( '<li class="jump-link-heading"><a href="#' + val.id + '">' + val.text + '</a></li>' );
        } else {
          $( '.jump-links-wrapper' ).append( '<li><a href="#' + val.id + '">' + val.text + '</a></li>' );
        }
      } );

      $( '.wysiwyg > *:header' ).each( function( key, val ) {
        let distance = 0;

        if ( $( '.wysiwyg > *:header' )[key + 1] ) {
          distance = $( $( '.wysiwyg > *:header' )[key + 1] ).offset().top - $( $( '.wysiwyg > *:header' )[key] ).offset().top;
        } else {
          const distanceInWysiwyg = $( $( '.wysiwyg > *:header' )[key] ).position().top;
          distance = $( '.wysiwyg' ).outerHeight( true ) - distanceInWysiwyg;
        }

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 175px',
            end: '+=' + distance,
            scrub: 0,
            toggleClass: {targets: $( '.jump-links-wrapper' ).find( 'a[href="#' + $( val ).attr( 'id' ) + '"]' ), className: 'is-active'},
          },
        } );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'post', COMPONENT );
} )( app );
